import { ReactNode } from "react";
import { Box, Button, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logo from "./Logo";

interface Props {
    title?: string;
    description?: string;
    action?: ReactNode;
    onClick?: () => void;
}

const Error = ({
    description = "Sorry an error occured",
    action,
    onClick,
    title,
}: Props) => {
    const navigate = useNavigate();

    function handleClick() {
        if (onClick) {
            onClick();
            return;
        }
        navigate(-1);
    }

    return (
        <Container
            component="main"
            sx={{
                display: "grid",
                placeItems: "center",
                minHeight: "75vh",
                textAlign: "center",
            }}
            maxWidth="md"
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Logo />
                {title && (
                    <Typography variant="h4" component="h2" my={2}>
                        {title}
                    </Typography>
                )}

                <Typography component="p" variant="h5" my={2}>
                    {description}
                </Typography>

                {action ? (
                    action
                ) : (
                    <Button
                        size="large"
                        type="submit"
                        variant="contained"
                        sx={{ mt: 3, mb: 2, py: 1.5, color: "white" }}
                        onClick={() => handleClick()}
                    >
                        Go Back
                    </Button>
                )}
            </Box>
        </Container>
    );
};

export default Error;
